var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"for-rent fill-height transparent flex-fill d-flex align-center flex-column"},[_c('HouseList',{attrs:{"data":_vm.store.data,"store":_vm.store,"header-panel":_vm.store.headerPanelForSale,"empty":_vm.store.status !== 1 ? _vm.store.data.length === 0 : false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }